module.exports = __webpack_public_path__ + "img/person-fill.3b596348.svg";